import { BranchModel } from "@WhiteCap/Services/ContactUsLocationsService";
import { ProvinceModel } from "@WhiteCap/Services/ContactUsLocationsService";

export interface BranchesState {
    provinces: ProvinceModel[],
    isLoading: boolean;
    error?: string;
}

const initialState: BranchesState = {
    provinces: [],
    isLoading: false,
    error: undefined,
};

export default function reducer(
    state: BranchesState = initialState,
    action: any
): BranchesState {
    switch (action.type) {

        case "Custom/Branches/BeginLoadBranches":
            return {
                ...state,
                isLoading: true,
                error: undefined,
            };

        case "Custom/Branches/CompleteLoadBranches":
            return {
                ...state,
                isLoading: false,
                provinces: action.result?.provinces || [],
            };

        case "Custom/Branches/FailedLoadBranches":
            return {
                ...state,
                isLoading: false,
                error: "Failed to load branches",
            };

        default:
            return state;
    }
}